import React from 'react';

const Card = ({ title, backgroundColor, textColor, cardStatus }) => {
  return (
    <div className={`w-full border-[1px] shadow-lg shadow-gray-500 coda-regular rounded  h-auto p-8`} style={{ backgroundColor, color: textColor }}>
      <h2 className='text-xl font-bold mb-2'>{title}</h2>
      {cardStatus && <p className='bg-yellow-500 text-xs right-0 border-white border rounded-br-none -top-2 w-fit absolute h-fit px-1 py-1 rounded wind-effect'>{cardStatus}</p>}
    </div>
  );
};

export default Card;